/**
 * Following the duck pattern, actions, constants and reducers are in the same file called module.js
 *
 * See: https://github.com/erikras/ducks-modular-redux
 *
 */
import { call, put, takeEvery } from 'redux-saga/effects'
import { getAPIUrl, request } from 'shared/services/networking'

export const GET_THANK_YOU_REQUEST = 'ThankYou/GET_THANK_YOU_REQUEST'
export const GET_THANK_YOU_SUCCESS = 'ThankYou/GET_THANK_YOU_SUCCESS'
export const GET_THANK_YOU_ERROR = 'ThankYou/GET_THANK_YOU_ERROR'

export function getThankYouRequest (id) {
  return {
    type: GET_THANK_YOU_REQUEST,
    payload: id
  }
}

export function getThankYouSuccess (thankYou) {
  return {
    type: GET_THANK_YOU_SUCCESS,
    payload: thankYou
  }
}

export function getThankYouError (error) {
  return {
    type: GET_THANK_YOU_ERROR,
    payload: error
  }
}

export function * getThankYou (action) {
  const config = {
    method: 'get',
    url: `${getAPIUrl()}/widget/thank_you/${action.payload}/`
  }
  try {
    const thankYou = yield call(request, config)
    yield put(getThankYouSuccess(thankYou))
  } catch (error) {
    yield put(getThankYouError(error))
  }
}

export function * getThankYouSaga () {
  yield takeEvery(GET_THANK_YOU_REQUEST, getThankYou)
}

const initialState = {
  thankYou: null,
  error: null
}

/**
 * Following the duck pattern, the module.js file should export a reducer as a default function
 */
export function reducer (state = initialState, action) {
  switch (action.type) {
    case GET_THANK_YOU_REQUEST:
      return {
        ...state,
        thankYou: null,
        error: null
      }
    case GET_THANK_YOU_SUCCESS:
      return {
        ...state,
        thankYou: action.payload
      }
    case GET_THANK_YOU_ERROR:
      return {
        ...state,
        error: action.payload
      }
    default:
      return state
  }
}

export default reducer
